import { render, staticRenderFns } from "./kyzlzp.vue?vue&type=template&id=0c36c19c&scoped=true"
import script from "./kyzlzp.vue?vue&type=script&lang=js"
export * from "./kyzlzp.vue?vue&type=script&lang=js"
import style0 from "./kyzlzp.vue?vue&type=style&index=0&id=0c36c19c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c36c19c",
  null
  
)

export default component.exports